export default __webpack_public_path__ + "static/media/speaker-bg.8bb03434.png";